import { render } from "./indexMarketV2.vue?vue&type=template&id=61acc039&scoped=true"
import script from "./indexMarketV2.vue?vue&type=script&lang=js"
export * from "./indexMarketV2.vue?vue&type=script&lang=js"

import "./indexMarketV2.vue?vue&type=style&index=0&id=61acc039&lang=scss&scoped=true"

import exportComponent from "D:\\gitLab\\daily\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61acc039"]])

export default __exports__